import React from 'react';
import './App.css';
import Navbar from 'components/Navbar';
import MainSection from 'components/Mainsection';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <MainSection/>
    </div>
  );
}

export default App;
